import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import MeasureValue from "./controls/MeasureValue";
import ListValue from "./controls/ListValue";
import LongTextValue from "./controls/LongTextValue";
import LabeledValue from "./controls/LabeledValue";

export function ResiduoSolidoUrbanoList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value.map((residuoSolidoUrbano, index) => (
        <ListGroupObjectItem
          key={residuoSolidoUrbano.orden}
          index={index}
          value={residuoSolidoUrbano}
          indexLabel={t("residuoSolidoUrbano.orden")}
          deletable
          onDelete={(event) => {
            event.preventDefault();
            remove(index);
          }}
          editable
          onEdit={(event) => {
            event.preventDefault();
            select(index);
          }}
          disabled={disabled}
        >
          {({ value }) => (
            <Grid>
              <Row>
                <Col>
                  <MeasureValue
                    label={t("residuoSolidoUrbano.cantidad")}
                    value={value?.cantidad}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <ListValue
                    label={t("residuoSolidoUrbano.operacionesUnitarias")}
                    value={value?.operacionesUnitarias}
                    labelAttr="nombre"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LongTextValue
                    label={t("residuoSolidoUrbano.descripcion")}
                    value={value?.descripcion}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabeledValue
                    label={t("residuoSolidoUrbano.material")}
                    value={value?.material}
                    labelAttr="nombre"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabeledValue
                    label={t("residuoSolidoUrbano.destino")}
                    value={value?.destino}
                    labelAttr="nombre"
                  />
                </Col>
              </Row>
            </Grid>
          )}
        </ListGroupObjectItem>
      ))}
    </ListGroup>
  );
}
